import React from 'react';
import FourthStep from './FourthStep';

const Expo = ({initialState, secondState, thirdState, handleCurrentStep }) => {
  return (
    <FourthStep
      initialState={initialState}
      secondState={secondState}
      thirdState={thirdState}
      handleCurrentStep={handleCurrentStep}
    />
  );
};

export default Expo;
